import { Flex } from 'antd'
import { Container } from 'components/ui'
import useLayoutContext from 'components/ui/layout/services/layoutContext'
import useConverter from 'hooks/useConverter'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import 'swiper/css/effect-cards'
import { EffectCards } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { format } from 'utils/format'
import { imgUrl } from 'utils/imgUrl'
import useHomeContext from '../services/homeContext'

const Collection = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { i18n } = useTranslation()
  const language = useMemo(
    () => i18n.language as 'uz' | 'ru' | 'en',
    [i18n.language]
  )
  const { converter } = useConverter()
  const {
    state: { data }
  } = useHomeContext()

  const {
    state: { currency }
  } = useLayoutContext()

  return data ? (
    <div
      className="collection"
      style={{
        backgroundImage: `url(${imgUrl(data?.collection_background)})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }}
    >
      <Container size="xxl">
        <Flex wrap justify="space-between" gap={50}>
          <div>
            <h1 className="cormorant-title" style={{ marginBottom: 20 }}>
              {data.collection_name?.[language]}
            </h1>
            {/* <Button
              type="contained"
              onClick={() =>
                navigate(`categories/${data.collection_direction}`)
              }
            >
              <span>{t('home.collections.button')}</span>
            </Button> */}
          </div>
          <div className="collection-swiper-wrapper">
            <Swiper
              effect={'cards'}
              grabCursor={true}
              modules={[EffectCards]}
              className="collection-swiper"
              style={{
                width: '330px',
                height: '450px',
                overflow: 'visible',
                maxWidth: '100%'
              }}
            >
              {data.collections.map((collection) => (
                <SwiperSlide
                  className="collection-swiper-slide"
                  onClick={() => navigate(`product/${collection._id}`)}
                >
                  <img
                    src={imgUrl(collection?.main_image)}
                    alt={collection?.main_image?.alt}
                    loading="lazy"
                  />
                  <div>
                    <p>{collection.name[language]}</p>{' '}
                    {collection?.integration?.price && (
                      <p>
                        {format.money(
                          converter(
                            collection?.integration?.price,
                            collection?.integration?.currency_id,
                            currency
                          ),
                          currency
                        )}
                      </p>
                    )}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </Flex>
      </Container>
    </div>
  ) : null
}

export default Collection
